module.exports = __webpack_public_path__ + "static/media/foto-sendiri.a2e6b373.png";